import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './shared/authentication/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'dashboard-web';

  constructor(
    private translateService: TranslateService,
    private authenticationService: AuthenticationService) {
    translateService.addLangs(['en', 'nl']);
    translateService.setDefaultLang('en');
    translateService.use('nl');
  }

  ngOnInit(): void {
    this.authenticationService.scheduleSessionExpiryLogout();
  }
}

